module.exports = __webpack_public_path__ + "static/media/hemcap1.704b04b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/medicalDevices/hemcap1.jpg
// module id = 227
// module chunks = 0